import Swiper from 'swiper';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';

export default function () {

    performance.mark("Swiper module starts")

    const cs = getComputedStyle(document.documentElement);

    //MAIN BANNER
    const mainBanner = new Swiper('.main-banner', {
        modules: [Pagination, Autoplay],
        preloadImages: false,
        autoplay: {
            delay: 7000
        },
        lazy: false,
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        on: {
            beforeTransitionStart: function (instance) {

                const currentSlide = instance.slides[instance.activeIndex];
                const slideImg = currentSlide.querySelector('img');

                if (slideImg.hasAttribute('src')) return;

                currentSlide.classList.add('loaded');
                slideImg.setAttribute('src', slideImg.getAttribute('data-src'));
            }
        }
    });


    //MAIN PAGE PRODUCTS
    const slider1 = new Swiper('.slider1 .swiper', {
        modules: [Navigation],
        preloadImages: false,
        navigation: {
            nextEl: '.swiper-button-next.slider-button1',
            prevEl: '.swiper-button-prev.slider-button1'
        },
        loop: true,
        slidesPerView: 1,
        spaceBetween: 20,
    });


    //PRODUCERS
    const producersBanner = new Swiper('.producers-banner .swiper', {
        modules: [Navigation],
        preloadImages: false,
        navigation: {
            nextEl: '.swiper-button-next.producer-button',
            prevEl: '.swiper-button-prev.producer-button'
        },
        loop: false,
        spaceBetween: 61,
        breakpoints: {
            1: {
                slidesPerView: 3,
                spaceBetween: 15
            },
            601: {
                slidesPerView: 3
            },
            1100: {
                slidesPerView: 4
            },
            1280: {
                slidesPerView: 5
            },
            1681: {
                slidesPerView: 6
            }
        }
    });

    performance.mark("Swiper module ends")

}